import { render, staticRenderFns } from "./DynamicCampaign.vue?vue&type=template&id=474e4012&scoped=true&"
import script from "./DynamicCampaign.vue?vue&type=script&lang=js&"
export * from "./DynamicCampaign.vue?vue&type=script&lang=js&"
import style0 from "./DynamicCampaign.vue?vue&type=style&index=0&id=474e4012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474e4012",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VContainer,VIcon,VOverlay,VRow})
